import SupportButton from './SupportButton';
import SupportDrawerBody from './SupportDrawerBody';

import './supportDrawer.scss';

const SupportDrawer = ({ currentPath, userRole }: { currentPath: string; userRole?: string }) => {
  return (
    <div className='support-drawer-container' data-testid='support-drawer-container'>
      <SupportButton />
      <SupportDrawerBody currentPath={currentPath} userRole={userRole} />
    </div>
  );
};

export default SupportDrawer;
